type Props = {
  selected: boolean,
  size?: number
}

export const RadioSelect: React.FC<Props> = ({ selected, size = 26 }) => {
  return (
    <div
      id="radio-select-outer-circle"
      style={{
        boxSizing: "border-box",
        height: `${size}px`,
        width: `${size}px`,
        borderRadius: "50%",
        border: `1px solid ${selected ? "#269C6E" : "#DBE1EB"}`,
        transition: "background-color 0.25s, border-color 0.25s",
        position: "relative",
      }}
    >
      <div
        id="radio-select-inner-circle"
        style={{
          boxSizing: "border-box",
          backgroundColor: selected ? "#269C6E" : "inherit",
          borderRadius: "50%",
          width: `${size - 8}px`,
          height: `${size - 8}px`,
          transition: "background-color 0.25s",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
      </div>
    </div>
  );
}
